import React from 'react';
import { AppBar, Toolbar, Box, IconButton } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { useNavigate, useMatch } from 'react-router-dom';
import ArrowBackRounded from '@mui/icons-material/ArrowBackRounded';

export default function NavBar() {
  const theme = useTheme();
  const navigate = useNavigate();
  const isFixturePage = useMatch('/fixture/:id');
  const logo = theme.palette.mode === 'dark'
    ? '/resources/logo/dark.svg'
    : '/resources/logo/light.svg';

  return (
    <AppBar
      position="fixed"
      elevation={0}
      sx={{
        bgcolor: theme.palette.mode === 'dark'
          ? 'rgba(18,18,18,0.7)'
          : 'rgba(245,245,245,0.7)',
        backdropFilter: 'blur(12px)',
        color: 'text.primary',
      }}
    >
      <Toolbar sx={{ gap: 1 }}>
        {isFixturePage && (
          <IconButton
            edge="start"
            onClick={() => navigate(-1)}
            sx={{ color: 'text.primary', mr: 0.5 }}
          >
            <ArrowBackRounded />
          </IconButton>
        )}
        <Box
          component="img"
          src={logo}
          alt="Turf"
          onClick={() => navigate('/')}
          sx={{ height: 28, cursor: 'pointer', display: 'block' }}
        />
      </Toolbar>
    </AppBar>
  );
}
